import { RouteObject } from 'react-router';

import SignupDetails from './Details';
import SignupList from './List';

export const SIGNUP_ROUTES: RouteObject[] = [
    { index: true, Component: SignupList },
    { path: ':id', Component: SignupDetails },
];
